import Immutable from 'seamless-immutable';
import AutoManualCompleteAddress from '@common/AutocompleteOrManualAddress';
import { ACTIONS } from './actions';

const { ADDRESS_INPUT_MODES } = AutoManualCompleteAddress;

export const initialState = Immutable.from({
  address: {
    addressLine1: '',
    addressLine2: '',
    city: '',
    stateOrProvince: '',
    postalCode: '',
    country: '',
  },
  addressInputMode: ADDRESS_INPUT_MODES.AUTOCOMPLETE,
  autocompletedAddress: '',
  endDate: null,
  isMapboxTokenActive: false,
  isSaving: false,
  jobNumber: '',
  missingRequiredField: true,
  projectName: '',
  projectValue: '',
  selectedAccount: null,
  selectedCurrency: { value: 'USD' },
  selectedPhase: null,
  selectedProjectType: null,
  selectedTemplate: null,
  selectedTimeZone: null,
  showDuplicateNameError: false,
  showInvalidProjectValueError: false,
  showModalConfirmation: false,
  startDate: null,
});

export const reducer = (state, action) => {
  switch (action.type) {
    case ACTIONS.RESET_ADDRESS:
      return state.merge({
        autocompletedAddress: '',
        address: initialState.address,
      });
    case ACTIONS.RESET_INPUT_STATE:
      return initialState.merge({
        isMapboxTokenActive: state.isMapboxTokenActive,
        addressInputMode: state.addressInputMode,
      });
    case ACTIONS.RESET_TEMPLATE_AND_PROJECT_TYPE:
      return state.merge({
        selectedTemplate: null,
        selectedProjectType: null,
      });
    case ACTIONS.SET_ADDRESS:
      return state.set('address', action.payload);
    case ACTIONS.SET_ADDRESS_INPUT_MODE:
      return state.set('addressInputMode', action.payload);
    case ACTIONS.SET_AUTOCOMPLETED_ADDRESS:
      return state.set('autocompletedAddress', action.payload);
    case ACTIONS.SET_CURRENCY:
      return state.set('selectedCurrency', action.payload);
    case ACTIONS.SET_END_DATE:
      return state.set('endDate', action.payload);
    case ACTIONS.SET_IS_SAVING:
      return state.set('isSaving', action.payload);
    case ACTIONS.SET_JOB_NUMBER:
      return state.set('jobNumber', action.payload);
    case ACTIONS.SET_MAPBOX_TOKEN_ACTIVE:
      return state.set('isMapboxTokenActive', action.payload);
    case ACTIONS.SET_MISSING_REQUIRED_FIELD:
      return state.set('missingRequiredField', action.payload);
    case ACTIONS.SET_PHASE:
      return state.set('selectedPhase', action.payload);
    case ACTIONS.SET_PROJECT_NAME:
      return state.set('projectName', action.payload);
    case ACTIONS.SET_PROJECT_VALUE:
      return state.merge({
        showInvalidProjectValueError: false,
        projectValue: action.payload,
      });
    case ACTIONS.SET_SELECTED_ACCOUNT:
      return state.set('selectedAccount', action.payload);
    case ACTIONS.SET_SELECTED_PROJECT_TYPE:
      return state.set('selectedProjectType', action.payload);
    case ACTIONS.SET_SELECTED_TEMPLATE:
      return state.set('selectedTemplate', action.payload);
    case ACTIONS.SET_SHOW_DUPLICATED_NAME_ERROR:
      return state.set('showDuplicateNameError', action.payload);
    case ACTIONS.SET_SHOW_INVALID_PROJECT_VALUE_ERROR:
      return state.merge({
        showInvalidProjectValueError: true,
        projectValue: '',
      });
    case ACTIONS.SET_SHOW_MODAL_CONFIRMATION:
      return state.set('showModalConfirmation', action.payload);
    case ACTIONS.SET_START_DATE:
      return state.set('startDate', action.payload);
    case ACTIONS.SET_TIME_ZONE:
      return state.set('selectedTimeZone', action.payload);
    default:
      return state;
  }
};
